import AdminTable from 'layouts/AdminTable';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { useTranslation } from 'react-i18next';
import { FormLabel, RadioGroup } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { useEffect, useState } from 'react';
import { get, post } from 'helpers/apiHelpers';
import { SelectInput } from 'components';
import Datetime from 'react-datetime';
import FormTextInputNoGrid from 'components/FormTextInput/FormTextInputNoGrid';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';
import { toast } from 'react-toastify';
import classNames from 'classnames';

const useStyles = makeStyles({
  ...buttonsStyle,
  ...extendedFormsStyle,
  radio: {
    padding: '10px 16px',
  },
  checkbox: {
    margin: '-7px -12px',
  },
  title: {
    marginLeft: '15px',
  },
  formLabelMarginTop: {
    marginTop: '20px',
  },
  formLabelMarginLeft: {
    marginLeft: '15px',
  },
});

const MAX_MESSAGE_LENGTH = 670;

const CreateSmsForm = ({ history }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [smsTags, setSmsTags] = useState([]);
  const [zones, setZones] = useState([]);
  const [usersAmount, setUsersAmount] = useState(0);

  const [smsConfiguration, setSmsConfiguration] = useState({
    processAt: new Date(),
    content: '',
    marketingTerms: 'gaveConsent',
    activeDiets: 'all',
    dayBagChecked: false,
    dayBagDate: null,
    bagZoneChecked: false,
    bagZone: {},
    smsClientTags: [],
    smsClientTagsFunctional: '',
  });

  useEffect(() => {
    get('/sms-client-tags', {
      pagination: false,
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(res => {
      const tags = res['hydra:member'].map(tag => ({
        label: tag['@id'],
        value: tag.value,
      }));
      setSmsTags(tags);
    });

    get('/zones', {
      pagination: false,
      properties: ['id', 'name'],
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(res => {
      // eslint-disable-next-line no-shadow -- FIXME
      const zones = res['hydra:member'].map(zone => ({
        value: zone.id,
        name: zone.name,
      }));
      setZones(zones);
    });
    // eslint-disable-next-line no-use-before-define -- FIXME
    getCurrentFiltersUsersAmount(smsConfiguration);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleChange = event => {
    const excludedFromUserAmountValidation = ['content'];
    const { name, value } = event.target;
    const updatedSmsConfiguration = {
      ...smsConfiguration,
      [name]: value,
    };
    setSmsConfiguration(updatedSmsConfiguration);
    if (!excludedFromUserAmountValidation.includes(name)) {
      // eslint-disable-next-line no-use-before-define -- FIXME
      getCurrentFiltersUsersAmount(updatedSmsConfiguration);
    }
  };

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    const updatedSmsConfiguration = {
      ...smsConfiguration,
      [name]: checked,
    };

    setSmsConfiguration(updatedSmsConfiguration);
    // eslint-disable-next-line no-use-before-define -- FIXME
    getCurrentFiltersUsersAmount(updatedSmsConfiguration);
  };

  const validateForm = () => {
    if (
      smsConfiguration.smsClientTags.length > 0 &&
      smsConfiguration.smsClientTagsFunctional === ''
    ) {
      return false;
    }
    return smsConfiguration.content && smsConfiguration.processAt;
  };

  const getCurrentFiltersUsersAmount = ({
    marketingTerms,
    activeDiets,
    dayBagChecked,
    dayBagDate,
    bagZoneChecked,
    bagZone,
    smsClientTags,
    smsClientTagsFunctional,
  }) => {
    const data = {
      ...(dayBagChecked ? { bagDate: dayBagDate } : {}),
      ...(bagZoneChecked && bagZone?.value ? { bagZone: bagZone.value } : {}),
      // eslint-disable-next-line no-negated-condition -- FIXME
      ...(activeDiets !== 'all'
        ? { hasActiveDiets: activeDiets === 'withActiveDiets' }
        : {}),
      // eslint-disable-next-line no-negated-condition -- FIXME
      ...(marketingTerms !== 'all'
        ? { smsConsent: marketingTerms === 'gaveConsent' }
        : {}),
      smsClientTags,
      smsClientTagsFunctional,
      type: 'sms',
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('/client-count-query', data).then(res => {
      setUsersAmount(res);
    });
  };

  const handleSubmit = () => {
    const {
      processAt,
      content,
      marketingTerms,
      activeDiets,
      dayBagChecked,
      dayBagDate,
      bagZoneChecked,
      bagZone,
      smsClientTags,
      smsClientTagsFunctional,
    } = smsConfiguration;

    const isValid = validateForm();
    if (!isValid || usersAmount === 0) {
      if (!isValid) {
        toast.error(t('sms.fillAllFields'));
      }
      if (usersAmount === 0) {
        toast.error(t('sms.userListCountZero'));
      }
      return;
    }
    const data = {
      processAt,
      content,
      filters: {
        bagDate: dayBagChecked && dayBagDate,
        bagZone: bagZoneChecked && bagZone.value,
        // eslint-disable-next-line no-negated-condition -- FIXME
        ...(activeDiets !== 'all'
          ? { hasActiveDiets: activeDiets === 'withActiveDiets' }
          : {}),
        // eslint-disable-next-line no-negated-condition -- FIXME
        ...(marketingTerms !== 'all'
          ? { smsConsent: marketingTerms === 'gaveConsent' }
          : {}),
        smsClientTags,
        smsClientTagsFunctional,
      },
    };

    post('/mass-sms', data)
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(history.push('/admin/mass-sms'))
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        toast.error(t('sms.smsNotCreated'));
      });
  };

  return (
    <>
      <h2>{t('sms.creatingSms')}</h2>
      <AdminTable>
        <GridContainer>
          <GridItem md={6}>
            <p className={classes.title}>{t('sms.smsTo')}</p>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('sms.marketingConsent')}
            </FormLabel>
            <GridItem className={classes.gridItem} md={12}>
              <RadioGroup
                name="marketingTerms"
                value={smsConfiguration.marketingTerms}
                onChange={handleChange}
              >
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.all')}
                  value="all"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.gaveConsent')}
                  value="gaveConsent"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.didNotGaveConsent')}
                  value="didNotGaveConsent"
                />
              </RadioGroup>
            </GridItem>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('sms.dietActivity')}
            </FormLabel>
            <GridItem md={12}>
              <RadioGroup
                name="activeDiets"
                value={smsConfiguration.activeDiets}
                onChange={handleChange}
              >
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.all')}
                  value="all"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.withActiveDiet')}
                  value="withActiveDiets"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('sms.withoutActiveDiet')}
                  value="withoutActiveDiets"
                />
              </RadioGroup>
            </GridItem>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('sms.bags')}
            </FormLabel>
            <GridItem md={12}>
              <LabeledCheckbox
                className={classes.checkbox}
                checked={smsConfiguration.dayBagChecked}
                onClick={handleCheckboxChange}
                label={t('sms.withDayBag')}
                name="dayBagChecked"
              />
            </GridItem>
            {smsConfiguration.dayBagChecked && (
              <GridItem md={6}>
                <Datetime
                  timeFormat={false}
                  dateFormat="YYYY-MM-DD"
                  closeOnSelect={true}
                  value={smsConfiguration.dayBagDate}
                  onChange={e => {
                    setSmsConfiguration(prev => ({
                      ...prev,
                      dayBagDate: e.format('DD.MM.YYYY'),
                    }));
                    getCurrentFiltersUsersAmount({
                      ...smsConfiguration,
                      dayBagDate: e.format('DD.MM.YYYY'),
                    });
                  }}
                  inputProps={{
                    placeholder: t('sms.setDate'),
                    readOnly: true,
                  }}
                />
              </GridItem>
            )}
            <GridItem md={12}>
              <LabeledCheckbox
                className={classes.checkbox}
                checked={smsConfiguration.bagZoneChecked}
                onClick={handleCheckboxChange}
                label={t('sms.withBagZone')}
                name="bagZoneChecked"
              />
            </GridItem>
            {smsConfiguration.bagZoneChecked && (
              <GridItem md={6}>
                <SelectInput
                  options={zones}
                  value={smsConfiguration.bagZone}
                  mapBy="name"
                  trackBy="value"
                  classes={classes}
                  handleChange={(e, option) => {
                    setSmsConfiguration(prev => ({
                      ...prev,
                      bagZone: option,
                    }));
                    getCurrentFiltersUsersAmount({
                      ...smsConfiguration,
                      bagZone: option,
                    });
                  }}
                />
              </GridItem>
            )}
            <GridItem md={8}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('sms.tags')}
              </FormLabel>
              <SelectInput
                noGrid={true}
                classes={classes}
                mapBy="value"
                trackBy="label"
                name="smsClientTags"
                multiple={true}
                value={smsConfiguration.smsClientTags}
                options={smsTags}
                disabled={false}
                handleChange={handleChange}
              />
            </GridItem>
            <GridItem md={8}>
              <FormLabel className={classNames(classes.labelHorizontal)}>
                {t('sms.tagsDescription')}
                {smsConfiguration.smsClientTags.length > 0 ? ' *' : null}
              </FormLabel>
              <SelectInput
                noGrid={true}
                classes={classes}
                mapBy="name"
                trackBy="value"
                name="smsClientTagsFunctional"
                value={smsConfiguration.smsClientTagsFunctional}
                options={[
                  {
                    name: t('sms.tagi.description.clear'),
                    value: '',
                  },
                  {
                    name: t('sms.tagi.description.send'),
                    value: 'YES',
                  },
                  {
                    name: t('sms.tagi.description.notSend'),
                    value: 'NO',
                  },
                ]}
                disabled={false}
                handleChange={handleChange}
              />
            </GridItem>
            <GridItem md={12}>
              <p className={classes.formLabelMarginTop}>
                {t('sms.recCount')}: <b>{usersAmount}</b>
              </p>
            </GridItem>
          </GridItem>
          <GridItem md={6}>
            <span className={classNames(classes.formLabelMarginLeft)}>
              {t('sms.message')}
            </span>

            <GridItem md={12}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('sms.deliveryDate')} *
              </FormLabel>
              <Datetime
                timeFormat={true}
                closeOnSelect={true}
                value={smsConfiguration.processAt}
                name="processAt"
                onChange={date => {
                  setSmsConfiguration(prev => ({
                    ...prev,
                    processAt: date,
                  }));
                }}
                isValidDate={day =>
                  day.isAfter(Datetime.moment().subtract(1, 'day'))
                }
                inputProps={{
                  placeholder: t('sms.setDate'),
                  readOnly: true,
                }}
              />
            </GridItem>
            <GridItem md={12}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('sms.content')} *
              </FormLabel>
              <FormTextInputNoGrid
                label={t('sms.content')}
                classes={classes}
                name="content"
                value={smsConfiguration.content}
                handleChange={handleChange}
                maxLength={MAX_MESSAGE_LENGTH}
                rows={2}
                rowsMax={30}
                multiline={true}
              />
              <span>
                {t('sms.charsLeftToUse')}:{' '}
                {MAX_MESSAGE_LENGTH - smsConfiguration.content.length}/
                {MAX_MESSAGE_LENGTH}
              </span>
            </GridItem>
          </GridItem>
        </GridContainer>
      </AdminTable>
      <FormControlStickyButton
        isFixedToBottom={true}
        classes={classes}
        discardText={t('sms.cancel')}
        submitText={t('sms.addSms2')}
        cancelPath="/admin/mass-sms"
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default CreateSmsForm;
